import dayjs from 'dayjs'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { RangeValue } from 'types/shared'

// any so that we can pass filters with any content
export interface Filter {
  [key: string]: any
}

interface SelectedFiltersDisplayProps {
  selectedFilters: Filter
  filterKeyTitle: Record<any, string>
  dateFormat?: string
}

const formatDate = (date: dayjs.Dayjs, dateFormat: string) =>
  dayjs(date).format(dateFormat)

const mapDateFilter = (value: RangeValue<dayjs.Dayjs>, dateFormat: string) => (
  <>
    {value && value[0] && value[1] && (
      <>{`${formatDate(value[0], dateFormat)} - ${formatDate(
        value[1],
        dateFormat
      )}`}</>
    )}
  </>
)

const SelectedFiltersDisplay = ({
  selectedFilters,
  filterKeyTitle,
  dateFormat = 'D.MM.YYYY'
}: SelectedFiltersDisplayProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  if (!selectedFilters || Object.keys(selectedFilters).length === 0) {
    return <FilteredText>{t(incidentReportsConstants.NO_FILTERS)}</FilteredText>
  }

  return (
    <div>
      <FilteredText>{t(incidentReportsConstants.FILTERED_BY)} </FilteredText>
      {Object.entries(selectedFilters).map(([key, value], index) => (
        <Fragment key={key}>
          <FilteredText>{`${filterKeyTitle[key]} - `}</FilteredText>
          <FilteredTextDark>
            {key === 'rangePicker'
              ? mapDateFilter(value as RangeValue<dayjs.Dayjs>, dateFormat)
              : (value as string[]).join(', ')}
            {index !== Object.keys(selectedFilters).length - 1 && (
              <FilteredText>
                {' '}
                {t(incidentReportsConstants.AND_BY)}{' '}
              </FilteredText>
            )}
          </FilteredTextDark>
        </Fragment>
      ))}
    </div>
  )
}

const BaseFilteredText = styled.span`
  font-family: ${(props) => props.theme.font.family.sansSerif};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`

const FilteredText = styled(BaseFilteredText)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const FilteredTextDark = styled(BaseFilteredText)`
  color: ${(props) => props.theme.color.neutral.color4};
`

export default SelectedFiltersDisplay
